import * as Actions from "../actions";
import { AdminState } from "../state";

export function updateAppInState(
    state: AdminState,
    action: Actions.AdminUpdateAppEndAction | Actions.TransferAppEndAction
): AdminState {
    const newApp = action.payload.app;

    if (newApp) {
        // replace the old app with the new
        const apps = state.apps.map(app => (newApp.appId === app.appId ? newApp : app));
        return {
            ...state,
            apps,
            error: {
                ...state.error,
                [action.type]: undefined
            }
        };
    }

    return state;
}
